import createDataStore from './CreateDataContext';
import { fetchArtists } from '../api/appAPI';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_ARTISTS':
      return action.payload;
    default:
      return [];
  }
};

const fetchArtistsAction = (dispatch) => async () => {
  const artists = await fetchArtists();
  dispatch({ type: 'FETCH_ARTISTS', payload: artists });
};

export const { Context, Provider } = createDataStore(
  reducer,
  { fetchArtistsAction },
  []
);
